/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useState } from 'react';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import { getAllBrand, deleteBrand } from 'src/services/brandService';
import { IconButton, Menu, MenuItem } from '@mui/material';
import type { TableColumn } from 'react-data-table-component';
import MUIModal from '../MUIModal/MUIModal';
import AddBrandForm from './AddBrandForm';
import EditBrandForm from './EditBrandForm';
import GradientButton from '../MUICustomButton/GradientButton';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import { ARE_YOU_SURE, DELETE_BRAND, DELETE_BRAND_SUCCESS_MESSAGE } from 'src/constants/constant';
import OutlineButton from '../MUICustomButton/OutlineButton';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';
import type { RootState } from '../types/types';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {MoreVerticalSolidRounded} from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
//@ts-ignore
import { PencilEdit02Icon } from '@hugeicons-pro/core-stroke-rounded';
import {checkEventPermission} from "../../common/utility/utility";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;

interface BrandListPropType {
  "id": number;
  "clientId": number;
  "clientName": string;
  "brandName": string;
  "brandDescription": string;
  "isDeleted": boolean;
  "createdBy": number;
  "createdByUserName": string;
  "createdOn": string;
  "modifiedBy": number;
  "modifiedOn": string;
  "modifiedByUserName": string;
}

interface ApiResponse {
  status: number;
  data: {
    data: BrandListPropType[];
    result: number;
  };
}

const BrandList: React.FC = () => {

  const [brandListData, setBrandListData] = useState<BrandListPropType[]>([])
  const [brandSearchData, setBrandSearchData] = useState<BrandListPropType[]>([])
  const [openAddBrandModal, setOpenAddBrandModal] = useState<boolean>(false)
  const [openEditBrandModal, setOpenEditBrandModal] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [isModalSaveLoading, setIsModalSaveLoading] = useState<boolean>(false)
  const [brandInfoData, setBrandnfoData] = useState<any>();
  const [showDeleteBrandModal, setDeleteBrandModal] = useState<boolean>(false);
  const [brandId, setBrandId] = useState<number>(0)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
  const { user } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getbrandListData()
  }, [user])

  const getbrandListData = (): void => {
    setLoading(true)
    debugger
    const ClientId = user?.clientId ?? 0;
    getAllBrand(ClientId)
    .then(
      (res: ApiResponse) => {
        if (res.status === 200) {
          if(res.data.result === 1) {
          const brandArr: BrandListPropType[] = [];
          res.data.data.map((brand: any) => {
            brand.Name = `${brand.clientName}`
            brandArr.push(brand)
          })
          setBrandListData(brandArr)
          setBrandSearchData(brandArr)
        } else {
          setBrandListData([])
          setBrandSearchData([])
        }
        }
      }
    ) 
    .catch (
      (      error: any) => console.log("Error: ", error)
    )
    .finally(() => {
      setLoading(false)
    })
  }

  const handleAddBrandClick = (): void => {
    setOpenAddBrandModal(true)
  }

  const handleCloseAddBrandModal = (): void => {
    setOpenAddBrandModal(false)
  }

  const handleEditBrandClick = (id: number): void => {
    setBrandId(id);
    setOpenEditBrandModal(true)
  }

  const handleCloseEditBrandModal = (): void => {
    setOpenEditBrandModal(false)
  }

  const handleRefreshPage = (): void => {
    getbrandListData()
    handleCloseAddBrandModal()
    handleCloseEditBrandModal()
  }

  const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
    // anchorActionEl[id] = event.currentTarget
    setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
  }

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;
    let brandDataArr = [...brandListData]
    if (value !== "") {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
      brandDataArr = brandDataArr && brandDataArr.filter((brand: BrandListPropType) => {
        return brand.brandName.toLowerCase().search(value.toLowerCase()) >= 0
      })
    }
    setBrandSearchData(brandDataArr)
  }

  const handleDeleteBrand = (id: number, brandName: string): void => {
      setBrandnfoData({ id, brandName });
      setDeleteBrandModal(true)
      setAnchorActionEl(null);
      setAnchorActionEl({ ...anchorActionEl, [id]: null });
    }
  
    const handleDeleteBrandClose = ():void => {
      setDeleteBrandModal(false)
    }
  
    const handleDeleteBrandConfirm = ():void => {
      setIsModalSaveLoading(true)
  
    const { id } = brandInfoData;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const userData = JSON.parse(localStorage.getItem("user"))
      
      const data = {
        "modifiedBy": userData.id,
        "id": id,
      }
  
      deleteBrand(data)
        .then(
          (res: ApiResponse) => {
            if(res.status === 200) {
              if(res.data.result === 1) {
                NotificationManager.success(DELETE_BRAND_SUCCESS_MESSAGE, '', 5000);
                setDeleteBrandModal(false)
                getbrandListData()
              }
            }
          }
        )
        .catch((error: any) => console.log("Error", error))
        .finally(() => setIsModalSaveLoading(false))
  }

  const columns: TableColumn<BrandListPropType>[] = [
    {
      name: 'Brand',
      selector: (row: BrandListPropType) => row.brandName,
      cell: (row: BrandListPropType) => {
        return (
          <div className="flex py-4 first:pt-0 last:pb-0" style={{ width: '100%' }}>
            <div className="overflow-hidden" style={{ width: '100%' }}>
              <p className="text-14 text-muted">{row.brandName}</p>
            </div>
          </div>
        )
      },
      width: '35%',
      sortable: true
    },
    {
      name: 'Description',
      selector: (row: BrandListPropType) => row.brandDescription,
      width: '50%',
      sortable: true
    },
    // {
    //   name: 'Status',
    //   sortable: false,
    //   width: "15%",
    //   // selector: row => row.year,
    //   cell: (row: BrandListPropType) => {
    //     return row.isActive ? <div className="badge truncate" style={{
    //       background: '#CCFFEA',
    //       padding: '10px 15px',
    //       color: '#06A864',
    //       border: '0px'
    //     }}>Active</div> : <div className="badge truncate" style={{
    //       background: '#FFF5F6',
    //       padding: '10px 15px',
    //       color: '#F13139',
    //       border: '0px'
    //     }}>Inactive</div>
    //   }
    // },
    {
      name: 'Actions',
      // selector: (row: any) => row.role,
      cell: (row: BrandListPropType) => {
        console.log("anchorActionEl", anchorActionEl)
        return (
          <div className='flex items-center'>
            <div onClick={() => handleEditBrandClick(row.id)} className="icon-hover-container" >
              <HugeiconsIcon
                icon={PencilEdit02Icon}
                size={20}
                color="#3A3A3A"
                strokeWidth={0.2}
              />
            </div>
            { checkEventPermission("BRANDS_DELETE") && 
            <div className='flex'>
              <IconButton
                aria-label="more"
                id="long-button"
                // aria-controls={open ? 'long-menu' : undefined}
                // aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={(e) => handleActionClick(e, row.id)}
              >
                 <HugeiconsIcon
                              icon={MoreVerticalSolidRounded}
                              size={20}
                              color="#3A3A3A"
                              strokeWidth={0.2}
                            />
              </IconButton>
              <Menu
                id={`${row.id}`}
                className='table-action-menu'
                MenuListProps={{
                  'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorActionEl[row.id]}
                open={Boolean(anchorActionEl[row.id])}
                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '18ch',
                  },
                }}
              >
                {/* <MenuItem onClick={() => handleactivatedeactivate(row.id, row.isActive, row.clientName)}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 19 19" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.5 0C4.26134 0 6.78571e-07 4.26134 0 9.5C6.78571e-07 14.7387 4.26134 19 9.5 19C14.7387 19 19 14.7387 19 9.5C19 4.26134 14.7387 0 9.5 0ZM9.5 1.35714C14.0052 1.35714 17.6429 4.99479 17.6429 9.5C17.6429 14.0052 14.0052 17.6429 9.5 17.6429C4.99479 17.6429 1.35714 14.0052 1.35714 9.5C1.35714 4.99479 4.99479 1.35714 9.5 1.35714Z" fill="#77869E" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M2.78219 2.78334C2.65497 2.9106 2.5835 3.08317 2.5835 3.26311C2.5835 3.44306 2.65497 3.61563 2.78219 3.74289L15.2576 16.2183C15.3206 16.2815 15.3955 16.3316 15.4779 16.3658C15.5604 16.4 15.6487 16.4176 15.738 16.4176C15.8273 16.4176 15.9156 16.4 15.9981 16.3658C16.0805 16.3316 16.1554 16.2815 16.2184 16.2183C16.3457 16.091 16.4171 15.9184 16.4171 15.7385C16.4171 15.5585 16.3457 15.386 16.2184 15.2587L3.74306 2.78334C3.68003 2.72015 3.60514 2.67001 3.5227 2.6358C3.44026 2.60159 3.35188 2.58398 3.26263 2.58398C3.17337 2.58398 3.08499 2.60159 3.00255 2.6358C2.92011 2.67001 2.84523 2.72015 2.78219 2.78334Z" fill="#77869E" />
                  </svg> <span style={{ paddingLeft: '15px' }} className='text-muted font-normal'>{row.isActive ? "Deactivate" : "Activate"}</span>
                </MenuItem> */}
                <MenuItem onClick={() => handleDeleteBrand(row.id, row.brandName)}>
                  <span style={{ paddingLeft: '15px', color: '#F13139' }}>Delete Brand</span>
                </MenuItem>
              </Menu>
            </div>
      }
          </div>
        )
      },
      width: '10%',
      sortable: false
    },

  ]

  return (
    <>
      <h2 className="text-2xl font-semibold text-title">Manage Brands</h2>
      <div className="flex my-5 gap-x-2 justify-between items-center">
        <div className="basis-3/5">
          <div className="form-control">
            <input type="text" placeholder="Search by brand" className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full" onChange={handleSearch} />
          </div>
        </div>
        <div className="basis-2/5 justify-end flex">
  {checkEventPermission("BRANDS_ADD") && 
          <GradientButton color='red' onClick={handleAddBrandClick}>
            <span style={{
              width: "20px",
              height: "20px",
              background: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "50px",
              marginRight: "5px"
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
              </svg>
            </span>
            Add New Brand
          </GradientButton>
}
        </div>
      </div>
      <div className='data-table-container mb-10'>
        <CustomDataTable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          columns={columns}
          data={brandSearchData}
          pagination
          // selectableRows
          progressPending={loading}
        />

        <MUIModal title='Add New Brand' openModal={openAddBrandModal} closeModal={handleCloseAddBrandModal} width={'50%'} >
          <AddBrandForm closeModal={handleCloseAddBrandModal} refreshPage={handleRefreshPage} />
        </MUIModal>
        <MUIModal title='Edit Brand' openModal={openEditBrandModal} closeModal={handleCloseEditBrandModal} width={'50%'} >
          <EditBrandForm closeModal={handleCloseEditBrandModal} refreshPage={handleRefreshPage} id = {brandId}/>
        </MUIModal>

        <BootstrapDialog
        onClose={handleDeleteBrandClose}
        aria-labelledby="customized-dialog-title"
        open={showDeleteBrandModal}
        PaperProps={{
          sx: {
            width: '550px',
            height: '200px'
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
          Delete Brand
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleDeleteBrandClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
         <HugeiconsIcon
                      icon={MultiplicationSignStrokeStandard}
                      size={24}
                      color="currentcolor"
                      strokeWidth={0.5}
                    /> 
        </IconButton>
        <DialogContent>
          <p className='text-14 text-muted'>{ARE_YOU_SURE} {DELETE_BRAND} <span className='font-semibold'>{brandInfoData?.brandName}</span>?</p>
        </DialogContent>
        <DialogActions sx={{ background: '#F9F9F9' }}>

          <OutlineButton color='gray' onClick={handleDeleteBrandClose} width='100px'>Cancel</OutlineButton>

          <GradientButton type='button' color='red' onClick={handleDeleteBrandConfirm} width='100px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
        </DialogActions>
      </BootstrapDialog>

      </div>
    </>
  );
};


export default BrandList;
